module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-solid-900.woff?e9f0ae7f477185792dca12c470a37558";